import { render, staticRenderFns } from "./PromotionsDashboard.vue?vue&type=template&id=66abfcfd&scoped=true&"
import script from "./PromotionsDashboard.vue?vue&type=script&lang=js&"
export * from "./PromotionsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsDashboard.vue?vue&type=style&index=0&id=66abfcfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66abfcfd",
  null
  
)

export default component.exports